// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/tabs.css
 ** module id = 205
 ** module chunks = 0
 **/